import React from "react";

function Comment(props) {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: `<!-- ${props.children} -->` }}
    ></div>
  );
}

export default Comment;
